{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartTitleEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.Forms, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCChart, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorListView, WEBLib.TMSFNCBitmapEditor
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit, FMX.SpinBox, FMX.Colors, FMX.Text, FMX.Edit, FMX.Layouts
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Samples.Spin
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Spin, ColorBox
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.ComCtrls
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  ,Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

  {$IFDEF VCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 5;
  MIDHEIGHTSPAC = 10;
  BIGHEIGHTSPAC = 15;
  {$ENDIF}
  {$IFDEF LCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF WEBLIB}
  CHECKBOXSIZE = 17;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 15;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF FMXLIB}
  CHECKBOXSIZE = 15;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  BIGDIV = 30;
  SMALLLBLSPACE = 10;
  MIDLBLSPACE = 20;
  BIGLBLSPACE = 30;
  SMALLHORSPACE = 60;
  MIDHORSPACE = 70;
  BIGHORSPACE = 80;
//  SERIESLARGECONTROLWIDTH = 100;
  LARGECONTROLWIDTH = 100;
  SMALLCONTROLWIDTH = 45;
  VALUE_MBYES = 6;


resourcestring
  sTMSFNCChartTitleEditorOK = 'OK';
  sTMSFNCChartTitleEditorCancel = 'Cancel';

  sTMSFNCChartTitleEditorTitle = 'Title';
  sTMSFNCChartTitleEditorText = 'Text';
  sTMSFNCChartTitleEditorTextMargins = 'Text Margins';
  sTMSFNCChartTitleEditorLeft = 'Left';
  sTMSFNCChartTitleEditorTop = 'Top';
  sTMSFNCChartTitleEditorRight = 'Right';
  sTMSFNCChartTitleEditorBottom = 'Bottom';
  sTMSFNCChartTitleEditorCenter = 'Center';
  sTMSFNCChartTitleEditorHeight = 'Height';
  sTMSFNCChartTitleEditorBorder = 'Border';
  sTMSFNCChartTitleEditorLine = 'Line';
  sTMSFNCChartTitleEditorValue = 'Value';
  sTMSFNCChartTitleEditorFill = 'Fill';
  sTMSFNCChartTitleEditorStroke = 'Stroke';
  sTMSFNCChartTitleEditorColor = 'Color';
  sTMSFNCChartTitleEditorColorTo = 'Color To';
  sTMSFNCChartTitleEditorVisible = 'Visible';
  sTMSFNCChartTitleEditorKind = 'Kind';
  sTMSFNCChartTitleEditorOpacity = 'Opacity';
  sTMSFNCChartTitleEditorWidth = 'Width';
  sTMSFNCChartTitleEditorPosition = 'Position';
  sTMSFNCChartTitleEditorName = 'Name';
  sTMSFNCChartTitleEditorFont = 'Font';
  sTMSFNCChartTitleEditorSize = 'Size';
  sTMSFNCChartTitleEditorHAlign = 'H-Align';
  sTMSFNCChartTitleEditorVAlign = 'V-Align';

  sTMSFNCChartTitleEditorSaveChartMessage = 'Are you sure you want to save the changes made?';
  sTMSFNCChartTitleEditorCancelChartMessage = 'Are you sure you don''t want to save the changes made?';
type
  TTMSFNCChartTitleEditor = class;

  {$IFDEF FMXLIB}
  TTMSFNCChartTitleEditorParent = TFmxObject;
  TTMSFNCChartTitleEditorComboBox = class(TComboBox);
  TTMSFNCChartTitleEditorSpinEdit = class(TSpinBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  TTMSFNCChartTitleEditorColorCombo = class(TComboColorBox);
  TTMSFNCChartTitleEditorAlphaTrackBar = class(TAlphaTrackBar);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCChartTitleEditorParent = TWinControl;
  TTMSFNCChartTitleEditorComboBox = class(TComboBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  {$IFNDEF LCLLIB}
  TTMSFNCChartTitleEditorSpinEdit = class(TSpinEdit);
  {$ENDIF}
  {$IFDEF LCLLIB}
  TTMSFNCChartTitleEditorSpinEdit = class(TFloatSpinEdit);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCChartTitleEditorColorCombo = class(TColorBox);
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCChartTitleEditorColorCombo = class(TWebColorPicker);
  {$ENDIF}
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCChartTitleEditor = class(TTMSFNCCustomComponent)
  private
    FBitmapEditor: TTMSFNCBitmapEditor;
    {$IFNDEF FMXLIB}
    FVertScrlBox: TScrollBox;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FVertScrlBox: TVertScrollBox;
    FTitFillOpacity, FTitStrokeOpacity: TTMSFNCChartTitleEditorAlphaTrackBar;
    {$ENDIF}
    FTitlePanel:TTMSFNCEditorPanel;

    FTitFillCol1, FTitFillCol2, FTitStrokeCol, FTitFontCol: TTMSFNCChartTitleEditorColorCombo;
    FTitFillKind, FTitStrokeKind, FTitHAlign, FTitVAlign, FTitFontName: TTMSFNCChartTitleEditorComboBox;
    FTitValue: TEdit;
    FTitTopCheck, FTitBottomCheck, FTitBorderCheck, FTitLineCheck, FTitVisibleCheck: TCheckBox;
    FTitAppLeft, FTitAppTop, FTitAppRight, FTitAppBottom, FTitStrokeWidth, FTitHeight, FTitSize: TTMSFNCChartTitleEditorSpinEdit;

    frm: TTMSFNCCustomDesignerForm;
    FPanel: TTMSFNCEditorPanel;
    FChart: TTMSFNCChart;
    FCopyChart: TTMSFNCChart;
    FButtonOk, FButtonCancel: TTMSFNCEditorButton;
    FModified: Boolean;
    procedure SetChart(const Value: TTMSFNCChart);
    function CancelChartMessage: Boolean;
    function SaveChartMessage: Boolean;
  protected
    {$IFDEF CMNWEBLIB}
    procedure SetColorComboStyle(AColorcombo: TTMSFNCChartTitleEditorColorCombo);
    {$ENDIF}
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure BuildEditor(AParent: TTMSFNCChartTitleEditorParent); virtual;
    procedure Initialize; virtual;
    procedure SetAppearance; virtual;
    procedure FillFonts;
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure CreateBottomPanel(AParent: TTMSFNCChartTitleEditorParent);
    procedure DoTitAppPosChange(Sender: TObject); virtual;
    procedure DoTitAppTitPosChange(Sender: TObject); virtual;
    procedure DoTitAppFillChange(Sender: TObject); virtual;
    procedure DoTitAppStrokeChange(Sender: TObject); virtual;
    procedure DoTitAppTextChange(Sender: TObject); virtual;
    procedure DoTitAppTextPosChange(Sender: TObject); virtual;
    procedure DoTitAppTextMarginsChange(Sender: TObject); virtual;
    procedure DoTitAppFontChange(Sender: TObject); virtual;
    {$IFDEF WEBLIB}
    procedure ApplyCSS(ACSS: string); virtual;
    {$ENDIF}
    function GetDocURL: string; override;
    function GetTipsURL: string; override;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Chart: TTMSFNCChart read FChart write SetChart;
  end;

  TTMSFNCChartTitleEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FChartEditor: TTMSFNCChartTitleEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AChartEditor: TTMSFNCChartTitleEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

  TTMSFNCChartTitleEditorDialog = class(TTMSFNCChartTitleEditor);

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.TMSFNCEditorsTools
  {$IFDEF FMXLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF VCLLIB}
  , VCL.Dialogs, VCL.Themes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,Dialogs
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.WebTools
  {$ENDIF}
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;

type
  TTMSFNCChartOpen = class(TTMSFNCChart);
//{$R TMSFNCChartTitleEditor.res}

{ TTMSFNCChartTitleEditor }

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

procedure TTMSFNCChartTitleEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FChart) then
    FChart := nil;
end;

procedure TTMSFNCChartTitleEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartTitleEditor);
end;

procedure TTMSFNCChartTitleEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCChartTitleEditor) then
    FChart := (Source as TTMSFNCChartTitleEditor).Chart;
end;

procedure TTMSFNCChartTitleEditor.BuildEditor(AParent: TTMSFNCChartTitleEditorParent);
var
  lbl1, lbl2, lbl3, lbl4 {$IFDEF CMNWEBLIB}, lbl5 {$ENDIF}: TLabel;
begin
  if Assigned(AParent) then
  begin
    {$IFDEF FMXLIB}
    FVertScrlBox := TVertScrollBox.Create(AParent);
    FVertScrlBox.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FVertScrlBox := TScrollBox.Create(AParent);
    FVertScrlBox.Align := alClient;
    FVertScrlBox.Top := 0;
    {$IFDEF LCLLIB}
    FVertScrlBox.HorzScrollBar.Visible:= False;
    {$ENDIF}
    {$ENDIF}
    FVertScrlBox.Parent := AParent;
    {$IFDEF CMNWEBLIB}
    FVertScrlBox.BorderStyle := bsNone;
    if IsLightTheme then
      FVertScrlBox.Color := EDITORSUBBACKCOLORLIGHT
    else
      FVertScrlBox.Color := EDITORSUBBACKCOLORDARK;
    {$ENDIF}


    //                  Title Panel
    //**************************************************
    FTitlePanel := TTMSFNCEditorPanel.Create(AParent);
    FTitlePanel.PanelPosition := eppCenter;
    {$IFDEF FMXLIB}
    FTitlePanel.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitlePanel.Align := alClient;
    {$ENDIF}
    FTitlePanel.Parent := AParent;

    lbl1 := TLabel.Create(FTitlePanel);
    lbl1.Parent := FTitlePanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := MIDLBLSPACE;
    lbl1.Position.Y := BIGHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartTitleEditorTitle);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := MIDLBLSPACE;
    lbl1.Top := BIGHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartTitleEditorTitle);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
    lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorPosition);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl1.Left + SMALLLBLSPACE;
    lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartTitleEditorPosition);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorTop);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorTop);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitTopCheck := TCheckBox.Create(FTitlePanel);
    FTitTopCheck.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitTopCheck.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FTitTopCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitTopCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitTopCheck.Height := CHECKBOXSIZE;
    FTitTopCheck.Width := CHECKBOXSIZE;
    FTitTopCheck.Left := lbl3.Left + SMALLHORSPACE;
    FTitTopCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorBottom);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorBottom);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitBottomCheck := TCheckBox.Create(FTitlePanel);
    FTitBottomCheck.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitBottomCheck.Position.X := FTitTopCheck.Position.X;
    FTitBottomCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitBottomCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitBottomCheck.Height := CHECKBOXSIZE;
    FTitBottomCheck.Width := CHECKBOXSIZE;
    FTitBottomCheck.Left := FTitTopCheck.Left;
    FTitBottomCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorHeight);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorHeight);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitHeight := TTMSFNCChartTitleEditorSpinEdit.Create(FTitlePanel);
    FTitHeight.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitHeight.DecimalDigits := 1;
    FTitHeight.Position.X := FTitTopCheck.Position.X;
    FTitHeight.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitHeight.Height)/2;
    FTitHeight.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitHeight.Left := FTitTopCheck.Left;
    FTitHeight.Top := lbl3.Top + (lbl3.Height - FTitHeight.Height) div 2;
    {$ENDIF}
    FTitHeight.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorBorder);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorBorder);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitBorderCheck := TCheckBox.Create(FTitlePanel);
    FTitBorderCheck.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitBorderCheck.Position.X := lbl4.Position.X + SMALLHORSPACE;
    FTitBorderCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitBorderCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitBorderCheck.Height := CHECKBOXSIZE;
    FTitBorderCheck.Width := CHECKBOXSIZE;
    FTitBorderCheck.Left := lbl4.Left + SMALLHORSPACE;
    FTitBorderCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorLine);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorLine);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitLineCheck := TCheckBox.Create(FTitlePanel);
    FTitLineCheck.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitLineCheck.Position.X := FTitTopCheck.Position.X;
    FTitLineCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitLineCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitLineCheck.Height := CHECKBOXSIZE;
    FTitLineCheck.Width := CHECKBOXSIZE;
    FTitLineCheck.Left := FTitTopCheck.Left;
    FTitLineCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorVisible);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorVisible);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitVisibleCheck := TCheckBox.Create(FTitlePanel);
    FTitVisibleCheck.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitVisibleCheck.Position.X := FTitTopCheck.Position.X;
    FTitVisibleCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitVisibleCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitVisibleCheck.Height := CHECKBOXSIZE;
    FTitVisibleCheck.Width := CHECKBOXSIZE;
    FTitVisibleCheck.Left := FTitTopCheck.Left;
    FTitVisibleCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := FTitHeight.Position.X + FTitHeight.Width + BIGLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorFill);
    lbl3.StyledSettings := lbl3.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := FTitHeight.Left + FTitHeight.Width + BIGLBLSPACE;
    lbl3.Top := lbl2.Top;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorFill);
    {$ENDIF}
    lbl3.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl3);

    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl3.Position.X + MIDLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl3.Left + MIDLBLSPACE;
    lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartTitleEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl2);

    FTitFillCol1 := TTMSFNCChartTitleEditorColorCombo.Create(FTitlePanel);
    FTitFillCol1.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitFillCol1.Width := SMALLCONTROLWIDTH;
    FTitFillCol1.Position.X := lbl2.Position.X + SMALLHORSPACE;
    FTitFillCol1.Position.Y := lbl2.Position.Y + (lbl2.Height - FTitFillCol1.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FTitFillCol1);
    FTitFillCol1.Width := LARGECONTROLWIDTH;
    FTitFillCol1.Left := lbl2.Left + SMALLHORSPACE;
    FTitFillCol1.Top := lbl2.Top + (lbl2.Height - FTitFillCol1.Height) div 2;
    {$ENDIF}

    {$IFDEF CMNWEBLIB}
    lbl5 := TLabel.Create(FTitlePanel);
    lbl5.Parent := FTitlePanel;

    lbl5.Left := lbl2.Left;
    lbl5.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
    lbl5.Caption := TranslateTextEx(sTMSFNCChartTitleEditorColorTo);
    SetEditorLabelAppearance(lbl5);
    {$ENDIF}

    FTitFillCol2 := TTMSFNCChartTitleEditorColorCombo.Create(FTitlePanel);
    FTitFillCol2.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitFillCol2.Position.X := FTitFillCol1.Position.X + FTitFillCol1.Width + SMALLLBLSPACE;
    FTitFillCol2.Position.Y := FTitFillCol1.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FTitFillCol2);
    FTitFillCol2.Left := FTitFillCol1.Left;
    FTitFillCol2.Top := lbl5.Top + (lbl5.Height - FTitFillCol2.Height) div 2;;
    {$ENDIF}
    FTitFillCol2.Width := FTitFillCol1.Width;

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl2.Position.X;
    lbl4.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl5.Left;
    lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitFillKind := TTMSFNCChartTitleEditorComboBox.Create(FTitlePanel);
    FTitFillKind.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitFillKind.Position.X := FTitFillCol1.Position.X;
    FTitFillKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitFillKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitFillKind.Left := FTitFillCol1.Left;
    FTitFillKind.Top := lbl4.Top + (lbl4.Height - FTitFillKind.Height) div 2;
    {$ENDIF}
    FTitFillKind.Items.Add('None');
    FTitFillKind.Items.Add('Solid');
    FTitFillKind.Items.Add('Gradient');
    FTitFillKind.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    lbl2.Position.X := lbl4.Position.X;
    lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorOpacity);
    SetEditorLabelAppearance(lbl2);

    FTitFillOpacity := TTMSFNCChartTitleEditorAlphaTrackBar.Create(FTitlePanel);
    FTitFillOpacity.Parent := FTitlePanel;
    FTitFillOpacity.Position.X := FTitFillKind.Position.X;
    FTitFillOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FTitFillOpacity.Height)/2;
    FTitFillOpacity.Width := FTitFillKind.Width;
    {$ENDIF}

    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := FTitFillOpacity.Position.X + FTitFillOpacity.Width + BIGLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorStroke);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := FTitFillKind.Left + FTitFillKind.Width + BIGLBLSPACE;
    lbl2.Top := lbl3.Top;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartTitleEditorStroke);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitStrokeCol := TTMSFNCChartTitleEditorColorCombo.Create(FTitlePanel);
    FTitStrokeCol.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FTitStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitStrokeCol.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FTitStrokeCol);
    FTitStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
    FTitStrokeCol.Top := lbl3.Top + (lbl3.Height - FTitStrokeCol.Height) div 2;
    {$ENDIF}
    FTitStrokeCol.Width := FTitFillCol1.Width;

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitStrokeKind := TTMSFNCChartTitleEditorComboBox.Create(FTitlePanel);
    FTitStrokeKind.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitStrokeKind.Position.X := FTitStrokeCol.Position.X;
    FTitStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitStrokeKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitStrokeKind.Left := FTitStrokeCol.Left;
    FTitStrokeKind.Top := lbl4.Top + (lbl4.Height - FTitStrokeKind.Height) div 2;
    {$ENDIF}
    FTitStrokeKind.Items.Add('None');
    FTitStrokeKind.Items.Add('Solid');
    FTitStrokeKind.Items.Add('Dash');
    FTitStrokeKind.Items.Add('Dot');
    FTitStrokeKind.Items.Add('DashDot');
    FTitStrokeKind.Items.Add('DashDotDot');
    FTitStrokeKind.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    lbl2.Position.X := lbl4.Position.X;
    lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorOpacity);
    SetEditorLabelAppearance(lbl2);

    FTitStrokeOpacity := TTMSFNCChartTitleEditorAlphaTrackBar.Create(FTitlePanel);
    FTitStrokeOpacity.Parent := FTitlePanel;
    FTitStrokeOpacity.Position.X := FTitStrokeKind.Position.X;
    FTitStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FTitStrokeOpacity.Height)/2;
    FTitStrokeOpacity.Width := LARGECONTROLWIDTH;
    {$ENDIF}

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorWidth);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorWidth);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitStrokeWidth := TTMSFNCChartTitleEditorSpinEdit.Create(FTitlePanel);
    FTitStrokeWidth.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitStrokeWidth.Min := 0;
    FTitStrokeWidth.DecimalDigits := 1;
    FTitStrokeWidth.Position.X := FTitStrokeKind.Position.X;
    FTitStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitStrokeWidth.Height)/2;
    FTitStrokeWidth.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitStrokeWidth.MinValue := 0;
    FTitStrokeWidth.Left := FTitStrokeKind.Left;
    FTitStrokeWidth.Top := lbl3.Top + (lbl3.Height - FTitStrokeWidth.Height) div 2;
    {$ENDIF}
    FTitStrokeWidth.Width := LARGECONTROLWIDTH;

    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
    lbl2.Position.Y := FTitVisibleCheck.Position.Y + FTitVisibleCheck.Height + BIGHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorText);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl1.Left + SMALLLBLSPACE;
    lbl2.Top := FTitVisibleCheck.Top + FTitVisibleCheck.Height + BIGHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartTitleEditorText);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorValue);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorValue);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitValue := TEdit.Create(FTitlePanel);
    FTitValue.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitValue.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FTitValue.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitValue.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitValue.Left := lbl3.Left + SMALLHORSPACE;
    FTitValue.Top := lbl3.Top + (lbl3.Height - FTitValue.Height) div 2;
    {$ENDIF}
    FTitValue.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorHAlign);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitHAlign := TTMSFNCChartTitleEditorComboBox.Create(FTitlePanel);
    FTitHAlign.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitHAlign.Position.X := FTitValue.Position.X;
    FTitHAlign.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitHAlign.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitHAlign.Left := FTitValue.Left;
    FTitHAlign.Top := lbl4.Top + (lbl4.Height - FTitHAlign.Height) div 2;
    {$ENDIF}
    FTitHAlign.Items.Add('Center');
    FTitHAlign.Items.Add('Left');
    FTitHAlign.Items.Add('Right');
    FTitHAlign.Width := FTitValue.Width;

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorVAlign);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorVAlign);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitVAlign := TTMSFNCChartTitleEditorComboBox.Create(FTitlePanel);
    FTitVAlign.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitVAlign.Position.X := FTitValue.Position.X;
    FTitVAlign.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitVAlign.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitVAlign.Left := FTitValue.Left;
    FTitVAlign.Top := lbl3.Top + (lbl3.Height - FTitVAlign.Height) div 2;
    {$ENDIF}
    FTitVAlign.Items.Add('Center');
    FTitVAlign.Items.Add('Top');
    FTitVAlign.Items.Add('Bottom');
    FTitVAlign.Width := FTitHAlign.Width;

    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := FTitVAlign.Position.X + FTitVAlign.Width + BIGLBLSPACE;
    lbl2.Position.Y := FTitVisibleCheck.Position.Y + FTitVisibleCheck.Height + BIGHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorTextMargins);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := FTitVAlign.Left + FTitVAlign.Width + BIGLBLSPACE;
    lbl2.Top := FTitVisibleCheck.Top + FTitVisibleCheck.Height + BIGHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartTitleEditorTextMargins);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorLeft);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorLeft);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitAppLeft := TTMSFNCChartTitleEditorSpinEdit.Create(FTitlePanel);
    FTitAppLeft.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitAppLeft.DecimalDigits := 1;
    FTitAppLeft.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FTitAppLeft.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitAppLeft.Height)/2;
    FTitAppLeft.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitAppLeft.Left := lbl3.Left + SMALLHORSPACE;
    FTitAppLeft.Top := lbl3.Top + (lbl3.Height - FTitAppLeft.Height) div 2;
    {$ENDIF}
    FTitAppLeft.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorTop);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorTop);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitAppTop := TTMSFNCChartTitleEditorSpinEdit.Create(FTitlePanel);
    FTitAppTop.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitAppTop.DecimalDigits := 1;
    FTitAppTop.Position.X := FTitAppLeft.Position.X;
    FTitAppTop.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitAppTop.Height)/2;
    FTitAppTop.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitAppTop.Left := FTitAppLeft.Left;
    FTitAppTop.Top := lbl4.Top + (lbl4.Height - FTitAppTop.Height) div 2;
    {$ENDIF}
    FTitAppTop.Width := LARGECONTROLWIDTH;

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorRight);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorRight);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitAppRight := TTMSFNCChartTitleEditorSpinEdit.Create(FTitlePanel);
    FTitAppRight.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitAppRight.DecimalDigits := 1;
    FTitAppRight.Position.X := FTitAppLeft.Position.X;
    FTitAppRight.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitAppRight.Height)/2;
    FTitAppRight.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitAppRight.Left := FTitAppLeft.Left;
    FTitAppRight.Top := lbl3.Top + (lbl3.Height - FTitAppRight.Height) div 2;
    {$ENDIF}
    FTitAppRight.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorBottom);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorBottom);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitAppBottom := TTMSFNCChartTitleEditorSpinEdit.Create(FTitlePanel);
    FTitAppBottom.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitAppBottom.DecimalDigits := 1;
    FTitAppBottom.Position.X := FTitAppLeft.Position.X;
    FTitAppBottom.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitAppBottom.Height)/2;
    FTitAppBottom.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitAppBottom.Left := FTitAppLeft.Left;
    FTitAppBottom.Top := lbl4.Top + (lbl4.Height - FTitAppBottom.Height) div 2;
    {$ENDIF}
    FTitAppBottom.Width := LARGECONTROLWIDTH;

    lbl2 := TLabel.Create(FTitlePanel);
    lbl2.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := FTitAppLeft.Position.X + FTitAppLeft.Width + BIGLBLSPACE;
    lbl2.Position.Y := FTitVisibleCheck.Position.Y + FTitVisibleCheck.Height + BIGHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartTitleEditorFont);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := FTitAppLeft.Left + FTitAppLeft.Width + BIGLBLSPACE;
    lbl2.Top := FTitVisibleCheck.Top + FTitVisibleCheck.Height + BIGHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartTitleEditorFont);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorName);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorName);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitFontName := TTMSFNCChartTitleEditorComboBox.Create(FTitlePanel);
    FTitFontName.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FTitFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitFontName.Height)/2;
    FTitFontName.ItemWidth := 240;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitFontName.Left := lbl3.Left + SMALLHORSPACE;
    FTitFontName.Top := lbl3.Top + (lbl3.Height - FTitFontName.Height) div 2;
    {$ENDIF}
    FTitFontName.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FTitlePanel);
    lbl4.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartTitleEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartTitleEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FTitFontCol := TTMSFNCChartTitleEditorColorCombo.Create(FTitlePanel);
    FTitFontCol.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitFontCol.Position.X := FTitFontName.Position.X;
    FTitFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FTitFontCol.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FTitFontCol);
    FTitFontCol.Left := FTitFontName.Left;
    FTitFontCol.Top := lbl4.Top + (lbl4.Height - FTitFontCol.Height) div 2;
    {$ENDIF}
    FTitFontCol.Width := LARGECONTROLWIDTH;

    lbl3 := TLabel.Create(FTitlePanel);
    lbl3.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartTitleEditorSize);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartTitleEditorSize);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FTitSize := TTMSFNCChartTitleEditorSpinEdit.Create(FTitlePanel);
    FTitSize.Parent := FTitlePanel;
    {$IFDEF FMXLIB}
    FTitSize.Min := 0;
    FTitSize.Position.X := FTitFontName.Position.X;
    FTitSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FTitSize.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTitSize.MinValue := 0;
    FTitSize.Left := FTitFontName.Left;
    FTitSize.Top := lbl3.Top + (lbl3.Height - FTitSize.Height) div 2;
    {$ENDIF}
    FTitSize.Width := LARGECONTROLWIDTH;


    //                     Bottom Panel
    //-------------------------------------------------------

    CreateBottomPanel(AParent);

    FillFonts;
    Initialize;
    SetAppearance;
  end;
end;

procedure TTMSFNCChartTitleEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if SaveChartMessage then
    {$ENDIF}
      frm.ModalResult := mrOk;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrOk;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartTitleEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if CancelChartMessage then
    {$ENDIF}
      frm.ModalResult := mrCancel;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrCancel;
    {$ENDIF}
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartTitleEditor.ApplyCSS(ACSS: string);
begin
//  FButtonOK.ElementClassName := 'IDEButton IDEFont';
//  FButtonCancel.ElementClassName := 'IDEButton IDEFont';
//  FButtonOpen.ElementClassName := 'IDEButton IDEFont';
//  FButtonClear.ElementClassName := 'IDEButton IDEFont';
//
//  FTopPanel.ElementClassName := 'IDEBkg';
//  FPanel.ElementClassName := 'IDEBkg';
end;
{$ENDIF}

function TTMSFNCChartTitleEditor.CancelChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartTitleEditorCancelChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

constructor TTMSFNCChartTitleEditor.Create(AOwner: TComponent);
begin
  inherited;
  FBitmapEditor := TTMSFNCBitmapEditor.Create(Self);
end;

procedure TTMSFNCChartTitleEditor.CreateBottomPanel(AParent: TTMSFNCChartTitleEditorParent);
begin
  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Bottom;
  FPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alBottom;
  {$ENDIF}
  FPanel.Parent := AParent;

  FPanel.Height := 37;

  FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
//    FButtonCancel.ModalResult := mrCancel;
  FButtonCancel.Parent := FPanel;
  FButtonCancel.Text := TranslateTextEx(sTMSFNCChartTitleEditorCancel);
  {$IFDEF FMXLIB}
  FButtonCancel.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonCancel.Align := alRight;
  FButtonCancel.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonCancel.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonCancel.BorderSpacing.Right := 5;
  FButtonCancel.BorderSpacing.Top := 5;
  FButtonCancel.BorderSpacing.Bottom := 5;
  FButtonCancel.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonCancel.Margins.Right := 5;
  FButtonCancel.Margins.Top := 5;
  FButtonCancel.Margins.Bottom := 5;
  FButtonCancel.Margins.Left := 5;
  {$ENDIF}
  FButtonCancel.OnClick := @DoButtonCancelClick;

  FButtonOK := TTMSFNCEditorButton.Create(FPanel);
//    FButtonOK.ModalResult := mrOk;
  FButtonOK.Parent := FPanel;
  FButtonOK.Text := TranslateTextEx(sTMSFNCChartTitleEditorOK);
  {$IFDEF FMXLIB}
  FButtonOk.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonOk.Align := alRight;
  FButtonOk.Left := 98;
  {$IFDEF VCLWEBLIB}
  FButtonOK.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonOK.Margins.Right := 0;
  FButtonOK.Margins.Top := 5;
  FButtonOK.Margins.Bottom := 5;
  FButtonOK.Margins.Left := 5;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonOK.BorderSpacing.Right := 0;
  FButtonOK.BorderSpacing.Top := 5;
  FButtonOK.BorderSpacing.Bottom := 5;
  FButtonOK.BorderSpacing.Left := 5;
  {$ENDIF}
  FButtonOK.OnClick := @DoButtonOKClick;
end;

destructor TTMSFNCChartTitleEditor.Destroy;
begin
  FBitmapEditor.Free;
  inherited;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCChartTitleEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCChartTitleEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;

  if Key = KEY_ESCAPE then
    DoButtonCancelClick(Self)
  else if Key = KEY_RETURN then
    DoButtonOKClick(Self);
end;

procedure TTMSFNCChartTitleEditor.DoTitAppFillChange(Sender: TObject);
begin
  FChart.Title.Fill.Kind := TTMSFNCGraphicsFillKind(FTitFillKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Title.Fill.Color := FTitFillCol1.Color;
  FChart.Title.Fill.ColorTo := FTitFillCol2.Color;
  FChart.Title.Fill.Opacity := FTitFillOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Title.Fill.Color := FTitFillCol1.Selected;
  FChart.Title.Fill.ColorTo := FTitFillCol2.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartTitleEditor.DoTitAppFontChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Title.Font.Color := FTitFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Title.Font.Color := FTitFontCol.Selected;
  {$ENDIF}
  FChart.Title.Font.Name := FTitFontName.Items[FTitFontName.ItemIndex];

  {$IFNDEF LCLLIB}
  FChart.Title.Font.Size := FTitSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Title.Font.Size := Round(FTitSize.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartTitleEditor.DoTitAppPosChange(Sender: TObject);
begin
  FChart.Title.Height := FTitHeight.Value;
  {$IFDEF FMXLIB}
  FChart.Title.Border := FTitBorderCheck.IsChecked;
  FChart.Title.Line := FTitLineCheck.IsChecked;
  FChart.Title.Visible := FTitVisibleCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Title.Border := FTitBorderCheck.Checked;
  FChart.Title.Line := FTitLineCheck.Checked;
  FChart.Title.Visible := FTitVisibleCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartTitleEditor.DoTitAppStrokeChange(Sender: TObject);
begin
  FChart.Title.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FTitStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Title.Stroke.Color := FTitStrokeCol.Color;
  FChart.Title.Stroke.Opacity := FTitStrokeOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Title.Stroke.Color := FTitStrokeCol.Selected;
  {$ENDIF}
  FChart.Title.Stroke.Width := FTitStrokeWidth.Value;

  FModified := True;
end;

procedure TTMSFNCChartTitleEditor.DoTitAppTextChange(Sender: TObject);
begin
  FChart.Title.Text := FTitValue.Text;
  FModified := True;
end;

procedure TTMSFNCChartTitleEditor.DoTitAppTextMarginsChange(Sender: TObject);
begin
  FChart.Title.TextMargins.Left := Round(FTitAppLeft.Value);
  FChart.Title.TextMargins.Top := Round(FTitAppTop.Value);
  FChart.Title.TextMargins.Right := Round(FTitAppRight.Value);
  FChart.Title.TextMargins.Bottom := Round(FTitAppBottom.Value);

  FModified := True;
end;

procedure TTMSFNCChartTitleEditor.DoTitAppTextPosChange(Sender: TObject);
begin
  FChart.Title.TextHorizontalAlignment := TTMSFNCGraphicsTextAlign(FTitHAlign.ItemIndex);
  FChart.Title.TextVerticalAlignment := TTMSFNCGraphicsTextAlign(FTitVAlign.ItemIndex);

  FModified := True;
end;

procedure TTMSFNCChartTitleEditor.DoTitAppTitPosChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  if FTitTopCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FTitTopCheck.Checked then
  {$ENDIF}
    FChart.Title.Positions := FChart.Title.Positions + [tipTop]
  else
    FChart.Title.Positions := FChart.Title.Positions - [tipTop];

  {$IFDEF FMXLIB}
  if FTitBottomCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FTitBottomCheck.Checked then
  {$ENDIF}
    FChart.Title.Positions := FChart.Title.Positions + [tipBottom]
  else
    FChart.Title.Positions := FChart.Title.Positions - [tipBottom];

  FModified := True;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartTitleEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCChartTitleEditor.Execute: TModalResult;
{$ENDIF}
begin
  if not Assigned(Chart) then
  begin
    raise Exception.Create('No chart was assigned to the editor!');
    Exit;
  end;

  {$IFDEF WEBLIB}
  frm := TTMSFNCChartTitleEditorForm.CreateDialogNew(Self, 'Chart Title Editor');
  {$ELSE}
  frm := TTMSFNCChartTitleEditorForm.CreateNew(Application);
  frm.Caption := 'Chart Title Editor';
  frm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  {$ENDIF}

  FCopyChart := TTMSFNCChart.Create(frm);
  FCopyChart.Assign(Chart);

  frm.Width := 730;
  frm.Height := 540;
  {$IFDEF FMXLIB}
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  frm.OnKeyDown := @DoFormKeyDown;
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  frm.ActiveControl := FTitlePanel;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) and Assigned(Chart) then
  begin
    Chart.Assign(nil);
    Chart.BeginUpdate;
    Chart.Assign(FCopyChart);
    Chart.EndUpdate;
    FCopyChart := nil;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) and Assigned(Chart) then
    begin
      Chart.Assign(nil);
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
      FCopyChart := nil;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

procedure TTMSFNCChartTitleEditor.FillFonts;
var
  sl: TStringList;
begin
  sl := TStringList.Create;
  try
    TTMSFNCUtils.GetFonts(sl);
    FTitFontName.Items.Assign(sl);
  finally
    sl.Free;
  end;
end;

function TTMSFNCChartTitleEditor.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncchart';
end;

function TTMSFNCChartTitleEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCChartTitleEditor.GetTipsURL: string;
begin
  Result := 'https://www.tmssoftware.com/site/tmsfncchart.asp?s=faq';
end;

procedure TTMSFNCChartTitleEditor.Initialize;
begin
  {$IFDEF FMXLIB}
  FTitTopCheck.IsChecked := tipTop in FChart.Title.Positions;
  FTitBottomCheck.IsChecked := tipBottom in FChart.Title.Positions;
  FTitBorderCheck.IsChecked := FChart.Title.Border;
  FTitLineCheck.IsChecked := FChart.Title.Line;
  FTitVisibleCheck.IsChecked := FChart.Title.Visible;
  FTitHeight.Value := FChart.Title.Height;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FTitTopCheck.Checked := tipTop in FChart.Title.Positions;
  FTitBottomCheck.Checked := tipBottom in FChart.Title.Positions;
  FTitBorderCheck.Checked := FChart.Title.Border;
  FTitLineCheck.Checked := FChart.Title.Line;
  FTitVisibleCheck.Checked := FChart.Title.Visible;
  FTitHeight.Value := Round(FChart.Title.Height);
  {$ENDIF}

  FTitFillKind.ItemIndex := Integer(FChart.Title.Fill.Kind);
  {$IFDEF FMXLIB}
  FTitFillCol1.Color := FChart.Title.Fill.Color;
  FTitFillCol2.Color := FChart.Title.Fill.ColorTo;
  FTitFillOpacity.Value := FChart.Title.Fill.Opacity;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FTitFillCol1.Selected := FChart.Title.Fill.Color;
  FTitFillCol2.Selected := FChart.Title.Fill.ColorTo;
  {$ENDIF}

  FTitStrokeKind.ItemIndex := Integer(FChart.Title.Stroke.Kind);
  {$IFDEF FMXLIB}
  FTitStrokeCol.Color := FChart.Title.Stroke.Color;
  FTitStrokeOpacity.Value := FChart.Title.Stroke.Opacity;
  FTitStrokeWidth.Value := FChart.Title.Stroke.Width;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FTitStrokeCol.Selected := FChart.Title.Stroke.Color;
  FTitStrokeWidth.Value := Trunc(FChart.Title.Stroke.Width);
  {$ENDIF}

  FTitValue.Text := FChart.Title.Text;
  FTitHAlign.ItemIndex := Integer(FChart.Title.TextHorizontalAlignment);
  FTitVAlign.ItemIndex := Integer(FChart.Title.TextVerticalAlignment);

  FTitAppLeft.Value := FChart.Title.TextMargins.Left;
  FTitAppTop.Value := FChart.Title.TextMargins.Top;
  FTitAppRight.Value := FChart.Title.TextMargins.Right;
  FTitAppBottom.Value := FChart.Title.TextMargins.Bottom;

  {$IFDEF FMXLIB}
  FTitFontCol.Color := FChart.Title.Font.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FTitFontCol.Selected := FChart.Title.Font.Color;
  {$ENDIF}
  FTitFontName.ItemIndex := FTitFontName.Items.IndexOf(FChart.Title.Font.Name);
  FTitSize.Value := FChart.Title.Font.Size;

  FTitHeight.OnChange := @DoTitAppPosChange;

  FTitFillKind.OnChange := @DoTitAppFillChange;
  {$IFDEF WEBLIB}
  FTitFillCol1.OnSelect := @DoTitAppFillChange;
  FTitFillCol2.OnSelect := @DoTitAppFillChange;
  FTitStrokeCol.OnSelect := @DoTitAppStrokeChange;
  FTitFontCol.OnSelect := @DoTitAppFontChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FTitFillCol1.OnChange := @DoTitAppFillChange;
  FTitFillCol2.OnChange := @DoTitAppFillChange;
  FTitStrokeCol.OnChange := @DoTitAppStrokeChange;
  FTitFontCol.OnChange := @DoTitAppFontChange;
  {$ENDIF}
  FTitStrokeWidth.OnChange := @DoTitAppStrokeChange;
  FTitStrokeKind.OnChange := @DoTitAppStrokeChange;

  {$IFDEF FMXLIB}
  FTitTopCheck.OnChange := @DoTitAppTitPosChange;
  FTitBottomCheck.OnChange := @DoTitAppTitPosChange;
  FTitBorderCheck.OnChange := @DoTitAppPosChange;
  FTitLineCheck.OnChange := @DoTitAppPosChange;
  FTitVisibleCheck.OnChange := @DoTitAppPosChange;
  FTitFillOpacity.OnChange := @DoTitAppFillChange;
  FTitStrokeOpacity.OnChange := @DoTitAppStrokeChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FTitTopCheck.OnClick := @DoTitAppTitPosChange;
  FTitBottomCheck.OnClick := @DoTitAppTitPosChange;
  FTitBorderCheck.OnClick := @DoTitAppPosChange;
  FTitLineCheck.OnClick := @DoTitAppPosChange;
  FTitVisibleCheck.OnClick := @DoTitAppPosChange;
  {$ENDIF}

  FTitValue.OnChange := @DoTitAppTextChange;
  FTitHAlign.OnChange := @DoTitAppTextPosChange;
  FTitVAlign.OnChange := @DoTitAppTextPosChange;

  FTitAppLeft.OnChange := @DoTitAppTextMarginsChange;
  FTitAppTop.OnChange := @DoTitAppTextMarginsChange;
  FTitAppRight.OnChange := @DoTitAppTextMarginsChange;
  FTitAppBottom.OnChange := @DoTitAppTextMarginsChange;

  FTitFontName.OnChange := @DoTitAppFontChange;
  FTitSize.OnChange := @DoTitAppFontChange;
end;

function TTMSFNCChartTitleEditor.SaveChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartTitleEditorSaveChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartTitleEditor.SetAppearance;
var
  {$IFDEF VCLLIB}
  LDetails: TThemedElementDetails;
  clr: TTMSFNCGraphicsColor;
  {$ENDIF}
  okfntCol, fntCol, fillCol, primCol: TTMSFNCGraphicsColor;
  SubPanelFillCol, SubPanelStrokecol, MainPanelCol: TTMSFNCGraphicsColor;
begin
  primCol := EDITORPRIMCOLOR;
  fillCol := EDITORAUTOCOLOR;
  fntCol := EDITORAUTOCOLOR;
  okfntCol := EDITOROKFONTCOLOR;
  SubPanelStrokeCol := EDITORAUTOCOLOR;
  SubPanelFillCol := EDITORAUTOCOLOR;
  MainPanelCol := EDITORAUTOCOLOR;
  {$IFDEF VCLLIB}
  if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
  begin
    clr := StyleServices.GetStyleColor(scButtonHot);
    if clr <> clNone then
      primCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonPressed);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      okfntCol := clr;

//    LDetails := StyleServices.GetElementDetails(ttbButtonHot);
//    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
//    begin
//      fc := clr;
//    end;

    LDetails := StyleServices.GetElementDetails(ttbButtonNormal);

    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      fillCol := clr;

    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      fntCol := clr;

    LDetails := StyleServices.GetElementDetails(tpPanelBackground);
    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      SubPanelFillCol := clr;
    if StyleServices.GetElementColor(LDetails, ecBorderColor, clr) and (clr <> clNone) then
      SubPanelStrokeCol := clr;

    clr := StyleServices.GetSystemColor(clBtnFace);
    if (clr <> clNone) then
    begin
      MainPanelCol := clr;
    end;
  end;
  FButtonOk.StyleElements := FButtonOk.StyleElements - [seClient];
  FButtonCancel.StyleElements := FButtonCancel.StyleElements - [seClient];

  FTitlePanel.StyleElements := FTitlePanel.StyleElements - [seClient];
  FPanel.StyleElements := FPanel.StyleElements - [seClient];
  {$ENDIF}

  SetEditorOKButtonAppearance(FButtonOk,primCol, EDITORBUTTONROUNDING, okfntCol);
  SetEditorCancelButtonAppearance(FButtonCancel, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);

  SetEditorSubPanelAppearance(FTitlePanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorBackPanelAppearance(FPanel, MainPanelCol, MainPanelCol);
end;

procedure TTMSFNCChartTitleEditor.SetChart(const Value: TTMSFNCChart);
begin
  FChart := Value;
end;

{$IFDEF FMXLIB}
{ TTMSFNCChartAppearanceEditorSpinEdit }

constructor TTMSFNCChartTitleEditorSpinEdit.Create(AOwner: TComponent);
begin
  inherited;
  Max := 100000;
  Min := -100000;
end;
{$ENDIF}

{$IFDEF CMNWEBLIB}
constructor TTMSFNCChartTitleEditorComboBox.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF VCLLIB}
  {$IF COMPILERVERSION > 34}
  AutoDropDownWidth := True;
  {$IFEND}
  {$ENDIF}
end;

procedure TTMSFNCChartTitleEditor.SetColorComboStyle(AColorcombo: TTMSFNCChartTitleEditorColorCombo);
begin
  {$IFNDEF WEBLIB}
  AColorcombo.Style := [cbStandardColors, cbExtendedColors, cbCustomColor];
  {$ENDIF}
end;
{$ENDIF}

{$IFDEF WEBLIB}

{ TTMSFNCChartTitleEditorForm }

constructor TTMSFNCChartTitleEditorForm.CreateDialogNew(AChartEditor: TTMSFNCChartTitleEditor; ACaption: string);
begin
  FChartEditor := AChartEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCChartTitleEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FChartEditor) then
  begin
    FChartEditor.BuildEditor(Self);
  end;
end;

procedure TTMSFNCChartTitleEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    if Assigned(FChartEditor) then
      FChartEditor.ApplyCSS(css);
  end;
end;
{$ENDIF}

end.
